export const handleError = (error) => {
    console.log('SOCKET - Error: ', error)
};